import { Component } from 'react';

import './RetrievalStatus.css';

import { background_3 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Counters from '../../components/Counters/Counters';

import classNames from 'classnames';
import { isAdmin } from '@acri-tools/react-tools/utils/_user_manager/login';
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import CreateRequest from '../../components/CreateRequest/CreateRequest';
import { axiosErrorHandler, nullUndefined } from '@acri-tools/react-tools/utils/global';
import { API_URL, get_page_title } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { BYTE_PREFIX, format_bytes, MISSION_COLOR_PALETTE, PREFIX } from '../../utils/data';
import { download_chart } from '../../utils/charts';
import Chart from 'react-apexcharts'
import UpdateRequest from '../../components/UpdateRequest/UpdateRequest';
import { create_toast } from '@acri-tools/react-tools/utils';
import { Helmet } from 'react-helmet';

const TAB_NAME = [
    'service-requests',
    'project-requests',
    'dcr-requests',
]

type ChartData = {
    label: string,
    percentage: number,
    value: number
}

interface Props {
}
interface State {
    order?: any
    loading_service: boolean
    loading_project: boolean
    loading_dcr: boolean
    list_toggled: boolean

    product_data_count?: number
    product_data_unit?: string

    product_count?: number
    product_unit?: string

    modal_open: boolean

    data_service?: any
    pie_data_service_number?: any
    pie_data_service_volume?: any

    data_project?: any
    pie_data_project_number?: any
    pie_data_project_volume?: any

    data_dcr?: any
    pie_data_dcr_number?: any
    pie_data_dcr_volume?: any

    selected_tab: number

    update_request?: any

    loadAllTargetProducts: boolean
}

export default class RetrievalStatus extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            list_toggled: true,
            loading_service: false,
            loading_project: false,
            loading_dcr: false,

            modal_open: false,
            selected_tab: 0,

            loadAllTargetProducts: false
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (
            this.state.selected_tab !== prevState.selected_tab
            || (this.state.data_service !== prevState.data_service)
            || (this.state.data_project !== prevState.data_project)
            || (this.state.data_dcr !== prevState.data_dcr)
        ) {
            this.tab_change(this.state.selected_tab);
        }
    }

    async componentDidMount() {
        await this.fetch_data();
    }

    fetch_data = async () => {
        let promises = [
            this.fetch_service_request(true),
            this.fetch_project_requests(true),
            this.fetch_dcr_requests(true)
        ];
        await Promise.all(promises);
    }

    fetch_service_request = async (force?: boolean) => {
        if (force) this.setState({ loading_service: true })
        try {
            let res = await request(`${API_URL}/api/v1/requests`, {
                method: 'get',
                params: {
                    filter: `type eq 'service'`
                }
            })

            let pie_data = this.format_pie_data(res.data.value);

            await this.setState({
                data_service: res.data.value,
                pie_data_service_number: pie_data?.number,
                pie_data_service_volume: pie_data?.volume
            })
        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'fetch_service_request'
            })
        }
        finally {
            if (force) this.setState({ loading_service: false })
        }
    }

    fetch_project_requests = async (force?: boolean) => {
        if (force) this.setState({ loading_project: true })
        try {
            let res = await request(`${API_URL}/api/v1/requests`, {
                method: 'get',
                params: {
                    filter: `type eq 'project'`
                }
            })

            let pie_data = this.format_pie_data(res.data.value);

            await this.setState({
                data_project: res.data.value,
                pie_data_project_number: pie_data?.number,
                pie_data_project_volume: pie_data?.volume
            })
        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'fetch_project_requests'
            })
        }
        finally {
            if (force) this.setState({ loading_project: false })
        }
    }

    fetch_dcr_requests = async (force?: boolean) => {
        if (force) this.setState({ loading_dcr: true })
        try {
            let res = await request(`${API_URL}/api/v1/requests`, {
                method: 'get',
                params: {
                    filter: `type eq 'dcr'`
                }
            })

            let pie_data = this.format_pie_data(res.data.value);

            await this.setState({
                data_dcr: res.data.value,
                pie_data_dcr_number: pie_data?.number,
                pie_data_dcr_volume: pie_data?.volume
            })
        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'fetch_dcr_requests'
            })
        }
        finally {
            if (force) this.setState({ loading_dcr: false })
        }
    }


    format_pie_data = (data: any) => {
        if (!data) return undefined;

        let entity_values: any = {};
        let total_number = 0;
        let total_volume = 0;

        for (let d of data) {
            let column = d.mission;
            try {
                let number = parseInt(d.nb_products) || 0;
                let volume = parseInt(d.volume) || 0;
                total_number += number;
                total_volume += volume;
                if (column in entity_values) {
                    entity_values[column].number += number;
                    entity_values[column].volume += volume;
                }
                else
                    entity_values[column] = { number, volume };
            }
            catch (e: any) { console.error(`Aggegation error`, d, e); }
        }

        let number: ChartData[] = [];
        let volume: ChartData[] = [];

        Object.keys(entity_values).forEach(((entity) => {
            number.push({
                label: entity,
                percentage: total_number === 0 ? 0 : parseFloat((entity_values[entity].number / total_number * 100).toFixed(2)),
                value: entity_values[entity].number
            })
            volume.push({
                label: entity,
                percentage: total_volume === 0 ? 0 : parseFloat((entity_values[entity].volume / total_volume * 100).toFixed(2)),
                value: entity_values[entity].volume
            })
        }))

        let sort = (a: ChartData, b: ChartData) => b.value - a.value;
        number.sort(sort)
        volume.sort(sort)

        // console.debug('pie data',number, volume )

        return { number, volume }

    }

    download_title = (title: string, type: 'volume' | 'number') => {
        return `${TAB_NAME[this.state.selected_tab]}_${title.toLowerCase().replace(/[\/\s]/g, '_')}`
    }

    get_pie_chart = (title: string, type: 'volume' | 'number', data: Array<any>) => {
        let id = `${title}`
        return (
            <div className="pie-chart">
                <div className="pie-chart-chart">
                    <Chart
                        type="pie"
                        series={data.map((d) => { return d.value })}
                        // height="100%"
                        height={400}
                        // width={400}
                        options={{

                            chart: {
                                id, // Id set to be downlaoded later
                            },
                            colors: MISSION_COLOR_PALETTE,
                            labels: data.map((d) => { return `${d.label} (${d.percentage}%)` }),
                            legend: {
                                // position: 'right'
                                position: 'bottom'
                                // position: this.state.big_mode ? 'bottom' : 'right'
                            },
                            tooltip: {
                                y: {
                                    formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
                                        return `${type === 'number' ? value : format_bytes(value, { base: 1000 })}`;
                                    }
                                }
                            }
                        }}
                    />
                </div>

                <div className="centered">
                    <div
                        className="custom-button small rounded shadow inline blue"
                        onClick={() => {
                            download_chart(id, this.download_title(title, type))
                        }}
                    >
                        <i className="fas fa-download" />
                        download chart
                        {/* <div className="tt-tooltip" > download</div> */}
                    </div>
                </div>
            </div>
        )
    }


    delete_request = async () => {
        let { order } = this.state;
        if (!window.confirm(`Are you sure you want to remove request ${order.name} ?`))
            return;
        order.removing_order = true;
        this.setState({ order })
        try {
            let res = await request(`${API_URL}/api/v1/requests/${order.id}`, {
                method: 'delete',
                params: {
                    filter: `type eq 'service'`
                }
            })

            create_toast({ type: 'success', message: `Sucessfully removed order ${order.name}` });
        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'delete_request'
            })
        }
        finally {
            this.fetch_data();
        }
    }

    render() {
        let tabs = [
            {
                label: <>Service Requests</>,
                content: <div>
                    {
                        this.state.loading_service ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.orders(this.state.data_service)
                    }
                </div>
            },
            {
                label: <>Project Requests</>,
                content: <div>
                    {
                        this.state.loading_project ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.orders(this.state.data_project)
                    }
                </div>
            },
            {
                label: <>DCR Requests</>,
                content: <div>
                    {
                        this.state.loading_dcr ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.orders(this.state.data_dcr)
                    }
                </div>
            }
        ]
        return (
            <Page
                id="retrieval-status"
                banner={{
                    title: "Retrieval Status",
                    bannerImage: background_3,
                    topBar: true
                }}
                footer
            >
                <Helmet>
                    <title>{get_page_title(`DAMPS - Retrieval Status`)}</title>
                    <meta
                        name="description"
                        content="DAMPS retrieval status details"
                    />
                </Helmet>
                {
                    isAdmin() &&
                    this.state.update_request &&
                    <>
                        <Modal
                            className="medium"
                            opened={!!this.state.update_request}
                            close={() => { this.setState({ update_request: undefined }) }}
                        >
                            <div className="modal-title">
                                UPDATE REQUEST <ModalClose close={() => { this.setState({ update_request: undefined }) }} />
                            </div>
                            <div className="modal-content">
                                <UpdateRequest
                                    request={this.state.update_request}
                                    onUpdate={(order) => {
                                        this.setState({ update_request: undefined, order });
                                        this.fetch_data();
                                    }}
                                />
                            </div>
                        </Modal>
                    </>
                }
                <div className="page-content">
                    <div className="centered-content padding">
                        <div className="retreival-status-metrics">
                            <div className="retreival-status-metric">
                                <Counters
                                    counters={[
                                        {
                                            name: "PRODUCT DATA",
                                            value: this.state.product_data_count,
                                            unit: this.state.product_data_unit,
                                        }
                                    ]}
                                />
                                {
                                    this.state.selected_tab === 0 ?
                                        this.state.data_service?.length > 0 &&
                                        this.get_pie_chart('product volume', 'volume', this.state.pie_data_service_volume)
                                        : this.state.selected_tab === 1 ?
                                            this.state.data_project?.length > 0 &&
                                            this.get_pie_chart('product volume', 'volume', this.state.pie_data_project_volume)
                                            :
                                            this.state.data_dcr?.length > 0 &&
                                            this.get_pie_chart('product volume', 'volume', this.state.pie_data_dcr_volume)
                                }
                            </div>
                            <div className="retreival-status-metric">
                                <Counters
                                    counters={[
                                        {
                                            name: "PRODUCTS",
                                            value: this.state.product_count,
                                            unit: this.state.product_unit,
                                        }
                                    ]}
                                />
                                {
                                    this.state.selected_tab === 0 ?
                                        this.state.data_service?.length > 0 &&
                                        this.get_pie_chart('product number', 'number', this.state.pie_data_service_number)
                                        : this.state.selected_tab === 1 ?
                                            this.state.data_project?.length > 0 &&
                                            this.get_pie_chart('product number', 'number', this.state.pie_data_project_number)
                                            :
                                            this.state.data_dcr?.length > 0 &&
                                            this.get_pie_chart('product number', 'number', this.state.pie_data_dcr_number)
                                }
                            </div>
                        </div>
                        {
                            isAdmin() &&
                            <>
                                <div
                                    className="custom-button blue inline medium"
                                    onClick={() => { this.setState({ modal_open: true }) }}
                                >
                                    <i className="fas fa-plus" /> ADD REQUEST
                                </div>
                                <br />
                                <br />

                                <Modal
                                    className="medium"
                                    opened={this.state.modal_open}
                                    close={() => { this.setState({ modal_open: false }) }}
                                >
                                    <div className="modal-title">
                                        ADD NEW REQUEST <ModalClose close={() => { this.setState({ modal_open: false }) }} />
                                    </div>
                                    <div className="modal-content">
                                        <CreateRequest
                                            onCreate={() => {
                                                this.fetch_data();
                                                this.setState({ modal_open: false });
                                            }}
                                        />
                                    </div>
                                </Modal>
                            </>
                        }
                        <Tabs
                            tabs={tabs}
                            onSelect={this.tab_change}
                        />

                    </div>
                </div>
            </Page>
        );
    }

    tab_change = (index: number) => {
        // 0 => SERVICE
        // 1 => PROJECT
        // 2 => DCR
        let orders = index === 0 ? this.state.data_service : index === 1 ? this.state.data_project : this.state.data_dcr;

        let product_data_count: any = 0;
        let product_count: any = 0;
        orders?.forEach((order: any) => {
            if (order.volume) product_data_count += order.volume;
            if (order.nb_products) product_count += order.nb_products;

        });
        let data_prefix_value = 0;
        let data_base = 1000;
        while (product_data_count > data_base) {
            product_data_count = product_data_count / data_base;
            data_prefix_value++;
        }

        let prefix_value = 0;
        while (product_count > 1000) {
            product_count = product_count / 1000;
            prefix_value++;
        }

        this.setState({
            selected_tab: index,
            order: orders?.[0] || undefined,
            product_data_count: product_data_count ? product_data_count.toFixed(3) : 0,
            product_data_unit: data_prefix_value ? BYTE_PREFIX[data_prefix_value] : "Bytes",
            product_count: prefix_value >= 1 ? product_count.toFixed(3) : product_count,
            product_unit: prefix_value >= 1 ? PREFIX[prefix_value] : undefined,
        })

    }


    string_attribute = (attribute: string, name: string) => {
        if (nullUndefined(this.state.order?.[attribute])) return null;
        return (
            this.state.order?.[attribute] !== '' &&
            <div className="order-details-data">
                <div className="order-details-data-name">{name}</div>
                <div className="order-details-data-value"> {this.state.order[attribute]} </div>
            </div>
        )
    }

    array_attribute = (attribute: string, name: string) => {
        if (nullUndefined(this.state.order?.[attribute])) return null;
        return (
            this.state.order?.[attribute].length !== 0 &&
            <div className="order-details-data">
                <div className="order-details-data-name">{name}</div>
                <div className="order-details-data-value"> {this.state.order[attribute].join?.(', ')} </div>
            </div>
        )
    }

    period_attribute = (attribute: string, name: string) => {
        if (nullUndefined(this.state.order?.[attribute])) return null;
        return (
            this.state.order?.[attribute].length !== 0 &&
            <div className="order-details-data">
                <div className="order-details-data-name">
                    {name}
                </div>
                <div className="order-details-data-value">
                    {
                        this.state.order[attribute].map((value: any) => {
                            return (
                                <div className="order-details-data-dates">
                                    <div className="order-details-data-date">
                                        <div className="order-details-data-date-label">
                                            Start
                                        </div>
                                        <div className="order-details-data-date-value">
                                            {value.start ? new Date(value.start)?.toISOString() : null}
                                        </div>
                                    </div>
                                    <div className="order-details-data-date">
                                        <div className="order-details-data-date-label">
                                            Stop
                                        </div>
                                        <div className="order-details-data-date-value">
                                            {value.stop ? new Date(value.stop)?.toISOString() : null}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    listTargetProducts = (products: any) => products.map((product: string, index: number) => (
        <div key={index} className="order-details-product">
            {product}
        </div>
    ));

    orders = (orders: Array<any>) => {
        if (!(orders?.length > 0)) {
            return (
                <div className="no-data">No orders</div>
            )
        }
        return (
            <div className="orders">
                <div
                    className={classNames({
                        "order-list-container": true,
                        "toggled": this.state.list_toggled
                    })}
                >
                    <div className="order-list-wrapper">
                        {
                            orders.length > 0 &&
                            <div className="order-list scrollbar">
                                {
                                    orders.map((order: any) => (
                                        <div
                                            className={classNames({
                                                "order-list-select": true,
                                                "selected": this.state.order && order.id === this.state.order.id
                                            })}
                                            onClick={() => { this.setState({ order, loadAllTargetProducts: false }) }}>
                                            {order.name}
                                        </div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                    <div className="order-list-toggle" onClick={() => { this.setState({ list_toggled: !this.state.list_toggled }) }}>
                        {
                            this.state.list_toggled ?
                                <i className="fas fa-chevron-left" />
                                :
                                <i className="fas fa-bars" />

                        }
                    </div>
                </div>
                {
                    this.state.order &&
                    <div className="order">
                        <div className="order-details-title main">
                            {this.state.order.name}

                            {
                                isAdmin() &&
                                <div className="request-operations">
                                    <div
                                        className="custom-button inline rounded shadow small green inverted"
                                        onClick={() => { this.setState({ update_request: this.state.order }) }}
                                    >
                                        <i className="fas fa-pen" />
                                        update
                                    </div>
                                    <div
                                        className={classNames({
                                            "custom-button inline rounded shadow small icon-only red inverted tt": true,
                                            "disabled": this.state.order.removing_order
                                        })}
                                        onClick={() => { this.delete_request() }}
                                    >
                                        {
                                            this.state.order.removing_order ?
                                                <Spinner white height={12} />
                                                :
                                                <>
                                                    <i className="fas fa-trash-alt" />
                                                    <div className="tt-tooltip">
                                                        delete
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="order-details">
                            <div className="order-details-data-container">
                                <div className="order-details-title">
                                    REQUEST DETAILS
                                </div>
                                <div className="order-details-data-list">
                                    <div className="order-details-data">
                                        <div className="order-details-data-name">Mission</div>
                                        <div className="order-details-data-value"> {this.state.order.mission} </div>
                                    </div>
                                    <div className="order-details-data">
                                        <div className="order-details-data-name">Instrument</div>
                                        <div className="order-details-data-value"> {this.state.order.instrument} </div>
                                    </div>
                                    {
                                        this.string_attribute('dataset_id', 'Dataset ID')
                                    }
                                    {
                                        this.array_attribute('product_type', 'Product Type')
                                    }
                                    {
                                        this.string_attribute('product_level', 'Product Level')
                                    }
                                    {
                                        this.array_attribute('filters', 'Filters')
                                    }
                                    {
                                        this.array_attribute('additional_requirements', 'Additional Requirements')
                                    }
                                    {
                                        this.string_attribute('nb_products', 'Number of products')
                                    }
                                    {
                                        this.state.order.volume !== null &&
                                        <div className="order-details-data">
                                            <div className="order-details-data-name">Volume</div>
                                            <div className="order-details-data-value"> {
                                                format_bytes(this.state.order.volume, { full: true, base: 1000 })
                                            }</div>
                                        </div>
                                    }
                                    {
                                        this.array_attribute('aoi', 'Area Of Interest')
                                    }
                                    {
                                        this.period_attribute('period', 'Period')
                                    }
                                    {
                                        this.string_attribute('repatriation_channel', 'Repatriation channel')
                                    }
                                    {
                                        this.string_attribute('user', 'User')
                                    }
                                </div>
                            </div>
                            {
                                this.state.order.target_products?.length > 0 &&
                                <div className="order-details-products-container">
                                    <div className="order-details-title">
                                        TARGET PRODUCTS
                                    </div>

                                    <div className="order-details-products">
                                        {
                                            this.state.loadAllTargetProducts ?
                                                this.listTargetProducts(this.state.order.target_products)
                                                :
                                                <>
                                                    <div>
                                                        {
                                                            this.listTargetProducts(this.state.order.target_products.slice(0, 27))
                                                        }
                                                    </div>
                                                    {
                                                        this.state.order.target_products.length > 28
                                                        &&
                                                        <button
                                                            name="load all products"
                                                            className='tp-load-more-btn custom-button small rounded shadow inline blue'
                                                            onClick={() => this.setState({ loadAllTargetProducts: true })}
                                                        >
                                                            Load all products
                                                        </button>
                                                    }
                                                </>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }
};

